import CodeAutoController from './code-automatique.controller';

export default {
    template: require('./code-automatique.form.html'),
    controller: CodeAutoController
};
